import type { IncomeGroupKey } from './types'

export const incomeGroupKeys: IncomeGroupKey[] = ['active', 'passive', 'other']

/**
 * Autocomplete only. An income position stores whatever name the user picked or typed,
 * so these are plain names instead of translation keys.
 */
export const incomeSuggestions: Record<IncomeGroupKey, string[]> = {
  active: ['Gehalt', 'Pension', 'Rente', 'Diäten', 'Besoldung', 'Honorar', 'Gewinn aus selbstständiger Tätigkeit'],
  passive: ['Mieteinnahmen', 'Dividenden', 'Zinsen', 'Tantiemen'],
  other: ['Kindergeld', 'Unterhalt', 'Erbschaften', 'Schenkungen'],
}

export const rentIncomeSuggestion = 'Mieteinnahmen'
